<template>
    <div id="overlay">
        <Toaster />
        <ModalGuidelines />
        <!--    you can add here your modals components -->
        <!--    you can add here your loader -->
    </div>
</template>
<script>
import Toaster from "../toaster/toaster.vue";
import ModalGuidelines from "../modal-guidelines/modal-guidelines.vue";

export default {
    name: "Overlay",
    components: {
        Toaster,
        ModalGuidelines,
    },
};
</script>
<style lang="scss">
#overlay {
    z-index: 2000;
}
</style>
